/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class CreateOrganizationDto {
  organisationName: string;
  parentId: string;
  tenantId: string;
  tags!: string[];
}
